import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=8e70f24e"
import script from "../../../controllers/custom/course/course-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/course/course-edit.js?vue&type=script&lang=js&external"
import style0 from "./CourseEdit.vue?vue&type=style&index=0&id=8e70f24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports